import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ActionSheetController,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { GenericFormValidationProvider } from '../../providers/common/form-validation';

/**
 * Generated class for the EditAddressPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-edit-address',
  templateUrl: 'edit-address.html',
})
export class EditAddressPage {
PropertyAddressSelComm:any;
remark:any;
errorDisplay:any={}
  constructor(
    private loadingCtrl:LoadingController,
    public actionSheetCtrl: ActionSheetController,
    private fv:GenericFormValidationProvider, 
    public navCtrl: NavController, 
    public navParams: NavParams,private cp:CommonProvider) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad EditAddressPage',this.navParams.get('queryParams'));
  }
 presentActionSheet(msg) {
    const actionSheet = this.actionSheetCtrl.create({
      title: msg,
      cssClass: 'commanSheet',
      buttons: [
        {
          text: "OK",
          role: 'Ok',
          handler: () => {
             actionSheet.dismiss();
          }
        }
      ]
    });
    actionSheet.present();
  }
  postFormForValidation(){
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
     
    if(this.errorDisplay.valid){
     return false;
   }else{
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    var ccs_casecategory="CC02";;
    var ccs_casetype="CT22";
    var ibhfl_loanaccountnumber1=localStorage.getItem('cc');
    var ccs_originatingsource="S011"
    var ccs_casesubtype = "ST109";
    var ccs_remarks = this.remark;
    var ccs_remarksaddress=this.remark;
    if(this.navParams.get('queryParams')){
      console.log(this.navParams.get('queryParams'));
       var ibhfl_countrycode=this.navParams.get('queryParams').countryid;
    var ibhfl_customername=this.navParams.get('queryParams').customername;
    var ibhfl_city=this.navParams.get('queryParams').cityid;
    var ibhfl_pincode=this.navParams.get('queryParams').pincode;
    var ibhfl_state=this.navParams.get('queryParams').stateid;
    var ibhfl_role=this.navParams.get('queryParams').applicanttype;
    var ibhfl_phone1=this.navParams.get('queryParams').phone1;
    var ibhfl_phone2=this.navParams.get('queryParams').phone2;
    var ibhfl_newmobileno=this.navParams.get('queryParams').mobile;
    var ibhfl_newemailid=this.navParams.get('queryParams').emailid;
    var ibhfl_addressline4=this.navParams.get('queryParams').address4;
    var ibhfl_typeofrectificationrequired=this.PropertyAddressSelComm;
    var ibhfl_stdcode=this.navParams.get('queryParams').stdcode;
    var ibhfl_addresstypes=this.navParams.get('queryParams').addresstype;
    }
   
   



    this.cp. postEditAddressSr(loading,ccs_remarks,ccs_remarksaddress,JSON.parse(localStorage.getItem("existingLoan"))[0].customercode
      ,ibhfl_loanaccountnumber1,
  ibhfl_countrycode,ibhfl_customername,ibhfl_city,ibhfl_pincode,
  ibhfl_state,ibhfl_role,ibhfl_phone1,ibhfl_phone2,ibhfl_newmobileno,ibhfl_newemailid,ibhfl_addressline4,
  ibhfl_typeofrectificationrequired,ibhfl_stdcode,ibhfl_addresstypes).then((res:any)=>{
    loading.dismiss()
                            var res=JSON.parse(res);
                             this.presentActionSheet("Your SRno. "+res.Payload.caseid+" has been resolved.")
                           })
   
    }
   }

}



// WEBPACK FOOTER //
// ./src/pages/edit-address/edit-address.ts